module.exports = __webpack_public_path__ + "media/customizations/nolina/logo-37bb10c348e40fbfbaf89f9f401c6722.png";